import { createContext, useContext, useState, ReactNode } from 'react';

interface ContactModalContextType {
  isOpen: boolean;
  toEmail: string;
  prefill: { subject: string; message: string } | null;
  openModal: (toEmail: string, subject?: string, message?: string) => void;
  closeModal: () => void;
}

const ContactModalContext = createContext<ContactModalContextType | undefined>(undefined);

export const ContactModalProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [toEmail, setToEmail] = useState('');
  const [prefill, setPrefill] = useState<{ subject: string; message: string } | null>(null);

  const openModal = (email: string, subject?: string, message?: string) => {
    setToEmail(email);
    setPrefill(subject || message ? { subject: subject || '', message: message || '' } : null);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setToEmail('');
    setPrefill(null);
  };

  return (
    <ContactModalContext.Provider value={{ isOpen, toEmail, prefill, openModal, closeModal }}>
      {children}
    </ContactModalContext.Provider>
  );
};

export const useContactModal = () => {
  const context = useContext(ContactModalContext);
  if (context === undefined) {
    throw new Error('useContactModal must be used within a ContactModalProvider');
  }
  return context;
};

